import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  searchInstitutions,
  searchInstitutionsSuccess,
  setSearchTerm
} from './institutions.actions';
import { InstitutionsService } from './institutions.service';
import { loadError } from '../error/error.action';
import { createActionError } from '../../models/action-error';
import { Institution } from 'src/generated/graphql';
import { InstitutionsFacadeService } from './institutions.facade';
import { InstitutionsFilterMapper } from '../../mappers/institutions-filter-mapper';

@Injectable()
export class InstitutionsEffects {
  constructor(
    private actions$: Actions,
    private institutionsService: InstitutionsService,
    private institutionsFacadeService: InstitutionsFacadeService
  ) {}

  public searchInstitutionsByFilter$ = createEffect(() =>
    this.actions$.pipe(
      ofType(searchInstitutions),
      switchMap(() => this.institutionsFacadeService.institutionsFilterInput$),
      switchMap((filterInput) =>
        this.institutionsService.getInstitutions(InstitutionsFilterMapper.dto(filterInput)).pipe(
          map(({ data }) =>
            searchInstitutionsSuccess({
              institutions: data.institutionsSearch?.results as Institution[],
              total: data.institutionsSearch?.total || 0
            })
          ),
          catchError((error) => {
            return of(
              loadError(createActionError(error.message ?? 'filter institutions failure.'))
            );
          })
        )
      )
    )
  );

  public searchInstitutionsByTerm$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setSearchTerm),
      switchMap(({ searchTerm }) =>
        this.institutionsService.getInstitutions(InstitutionsFilterMapper.dto({ searchTerm })).pipe(
          map(({ data }) =>
            searchInstitutionsSuccess({
              institutions: data.institutionsSearch?.results as Institution[],
              total: data.institutionsSearch?.total || 0
            })
          ),
          catchError((error) => {
            return of(
              loadError(createActionError(error.message ?? 'search institutions failure.'))
            );
          })
        )
      )
    )
  );
}
